export default __webpack_public_path__ + "assets/models/5529cd0d334b8c9e35a29f8f75c70702.glb";